import React from "react";
import { IScholarshipsAndFinancialData } from "../exports/interfaces";

const FinancialAidPolicy = ({
  scholarshipsAndFinancial,
}: {
  scholarshipsAndFinancial: IScholarshipsAndFinancialData[];
}) => {
  return (
    <div style={{ fontSize: "16px" }}>
      <h4
        style={{ textAlign: "center", marginBottom: "5px", fontSize: "18px" }}
      >
        {scholarshipsAndFinancial[0]?.title}
      </h4>
      <p style={{ textAlign: "center", margin: "0" }}>
        {scholarshipsAndFinancial[0]?.sub_title}
      </p>

      <br />

      <div
        dangerouslySetInnerHTML={{
          __html: scholarshipsAndFinancial[0]?.description,
        }}
      />
    </div>
  );
};

export default FinancialAidPolicy;
